import { store } from 'app/shared/store/store';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { ResponseError } from 'app/shared/models/response-error.error';
import { getHeaders } from 'app/shared/utilities/helper-functions';
import { GeneralContentCategoryItems } from 'app/shared/services/general-content/models/general-content-category-items.model';

class GeneralContentModel {
  constructor() {
    this.content = {};
    this.siteError = {};
  }

  content: { [key: string]: string } & { categoryItems?: GeneralContentCategoryItems[] };
  siteError: { [key: string]: string };
}

class GeneralContentService {
  public getGeneralContent = async (): Promise<GeneralContentModel> => {
    const configData = store.get(StoreKeys.configData);
    const searchEndpoint = `${configData.bffApiUrl}/general-content?spa=compare-products-spa`;

    const response = await fetch(searchEndpoint, {
      method: 'GET',
      headers: getHeaders()
    })
      .then((res) => {
        if (!res.ok) {
          if (res.status === 300) {
            throw new ResponseError(res.statusText, 'multipleMatching');
          } else if (res.status === 500) {
            throw new ResponseError(res.statusText, 'systemError');
          } else {
            throw new ResponseError('Unable to retrieve general content', 'serviceNotAvailable');
          }
        }
        return res.json() as Promise<GeneralContentModel>;
      })
      .catch((_) => {
        console.log('Could not get general content');
        return new GeneralContentModel();
      });

    return Promise.resolve(response);
  };
}

export const generalContentService = new GeneralContentService();
